import React from "react";
import { connect } from 'react-redux';

class IciciKycSuccess extends React.Component{
    constructor(props){
        super(props);
        this.state={
        }
    }

	closeTab = (event) => {
		window.close();
	}
    
      render(){
          return(
            <div class="mid-contant">
	            <div class="container">		
	          	<div class="row">
		        	<div class="col-12">
			      	<div class="head">
				      	<h2 class="success">KYC Process has been done successfuly!</h2>
			    	  </div>
			        </div>
			
			<div class="col-12">
				<div class="kycform">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<div class="table-responsive">
								<table class="table table-bordered table-striped">
									<tr>
										<td width="150">Full Name</td>
										<td>{this.props.name}</td>
									</tr>
									<tr>
										<td>Mobile Number</td>
										<td>{this.props.mobile}</td>
									</tr>
									<tr>
										<td>Aadhaar Number</td>
										<td>{this.props.aadhaarNumber}</td>
									</tr>
									<tr>
										<td>PAN Number</td>
										<td>{this.props.panNumber}</td>
									</tr>
									<tr>
										<td>Reference no.</td>
										<td>{this.props.orderDetails.orderId}</td>
									</tr>
									<tr>
										<td>Date & time</td>
										<td>{this.props.orderDetails.dateCreated}</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="col-12">
							<button type="button" class="btn btn-primary" onClick={this.closeTab} >Close</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
        );
      } 
}


const mapStateToProps = ({ onBoarding: { orderDetails, name, mobile, aadhaarNumber, panNumber } }) => ({
    orderDetails, name, mobile, aadhaarNumber, panNumber
});

export default connect(mapStateToProps, null)(IciciKycSuccess);